import { useMemo } from "react";
import { removeCitationBrackets } from "@/utils/parseCitations";
import type { PicoExtraction } from "@/types/models";

export function usePicoExportRows(
  extractions: PicoExtraction[],
  columns: { name: string }[]
): Record<string, string>[] {
  return useMemo(() =>
    extractions.flatMap((extraction) => {
      const metaRow: Record<string, string> = {
        "Document Title": extraction.studyName,
        "Author(s)": extraction.authors,
        "Country": extraction.countries.join(", "),
        "Year": extraction.year,
        "Source Type": extraction.sourceType,
        "Source Organisation": extraction.sourceOrganisation,
      };

      if (extraction.subgroups.length === 0) {
        columns.forEach((col) => { metaRow[col.name] = ""; });
        return [metaRow];
      }

      return extraction.subgroups.map((sg) => {
        const row = { ...metaRow };
        const picoFallback = [sg.population, sg.intervention, sg.comparator, sg.outcome];
        columns.forEach((col, idx) => {
          const fieldValue = sg.fields?.[col.name];
          let raw: string;
          if (!fieldValue) {
            raw = picoFallback[idx] ?? "";
          } else if (typeof fieldValue === "string") {
            raw = fieldValue;
          } else {
            raw = fieldValue.value ?? picoFallback[idx] ?? "";
          }
          row[col.name] = removeCitationBrackets(raw);
        });
        return row;
      });
    }),
    [extractions, columns]
  );
}
